import { useContext, useEffect } from 'react'
import { useSelector } from 'react-redux'
import Spinner from '@groovehq/internal-design-system/lib/components/Spinner/Spinner'
import SanitizedHTML from 'shared/components/ui/SanitizedHTML'
import ScrollerContext from 'components/Scroller/Context'
import { selectDraftReplyTextStreamingResult } from 'ducks/ai/selectors/streamingResults'

const StreamingResponse = () => {
  const content = useSelector(selectDraftReplyTextStreamingResult)
  const { getScrollerAPI } = useContext(ScrollerContext)

  useEffect(
    () => {
      const api = getScrollerAPI()
      if (api) {
        api.scrollToBottom()
      }
    },
    [getScrollerAPI, content]
  )

  return (
    <div>
      <SanitizedHTML className="body" html={content} />
      <Spinner size="small" className="grui mt-8" />
    </div>
  )
}

export default StreamingResponse
